import React, { Component } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import { connect } from 'react-redux'
import PendingTaskList from '../../components/TasksManagement/PendingTaskList';
import RegulariseAttendence from '../../components/_utils/regulariseAttendence';
import { Card, Tooltip, Button, Drawer, Form, Row, Col, DatePicker } from 'antd'
import Request, { API_URL, MEDIA_URL } from '../../request'
import { TableComp } from 'sz-react-utils'
import QRCode from "react-qr-code";
import { notification } from 'antd'
import moment from 'moment'
import { RightsWrapper } from '../../components/_utils/utils';
import AssignedTrainings from '../training/assignedTrainings';

// import DealerDashboard from './dealerDashboard'


let intVar = null;
let currentDate = moment().format('YYYY-MM-DD')
let activeUser = JSON.parse(localStorage.getItem('user'))

@Form.create()
class AcceptPolicy extends Component {
    state = {
        policies: {}
    }

    constructor(props) {
        super(props)
    }

    async componentDidMount() {
        let { policies } = this.props
        this.setState({ policies: policies })
    }




    handleButtonClick = (e) => {
        let data = {
            policyAccepted: Boolean(e.target.value)
        }
        this.props.handleSubmit(data)
    }

    checkScroll(e) {

    }


    render() {
        let { policies } = this.state
        return (
            <Card>
                <Row style={{ textAlign: 'center' }}>
                    <h4 style={{ fontSize: '20px' }}>Please carefully review and accept our company policies to complete your onboarding.</h4>
                    <iframe src={`${MEDIA_URL}${policies.url}`} width={1000} height={500} onScrollCapture={this.checkScroll} /><br></br>
                    <Button style={{ marginTop: '10px' }} value={true} onClick={this.handleButtonClick}>Accept</Button>
                </Row>
            </Card>
        )
    }
}

class Dashboard extends Component {
    state = {
        time: {
            from: moment().startOf('month').toDate(),
            to: moment().endOf('month').toDate(),
        },
        showRegularizeDrawer: false,
        attendenceRecord: {},
        previousRegularisationRequests: 0,
        count: 0,
        showPoliciesDrawer: false,
        user: {},
        policies: {},
        shiftTime: 0,
        trackAllUserAttendence: null,
        todayDate: moment(),
        selectedDate: moment().format("YYYY-MM-DD")
    }
    constructor(props) {
        super(props)
        this.table = React.createRef();
        this.tableAbsent = React.createRef();
    }

    getCurrentUser() {
        // let activeUser = JSON.parse(localStorage.getItem('user'))
        if (activeUser.shiftTiming) {
            let shiftTimings = activeUser.shiftTiming.split(' - ')
            let shiftStartTime = moment(shiftTimings[0], "HH:mm:ss A");
            let shiftEndTime = moment(shiftTimings[1], "HH:mm:ss A");
            let shiftWorkingHours = shiftEndTime.diff(shiftStartTime, 'hour');
            return shiftWorkingHours
        } else {
            return 0;
        }

    }

    async componentDidMount() {
        this.checkPolicyAccepted()
        if (localStorage.getItem('userLogout') == 'not') {
            localStorage.removeItem('userLogout');
            notification.warning({ message: "Your account was not logout, Please logout your account on daily BASIS.", duration: 40 })
        }
        intVar = setInterval(() => {
            this.setState({ timer: new Date() })

        }, 12000)
        let { data } = await Request.getPoliciesFile()
        data = (data[0] && data[0].itemValue && data[0].itemValue[0] ? data[0].itemValue[0] : '');
        this.setState({ policies: data })
        this.checkRegularisationRequests()
        this.getCompanyDetails()
    }


    componentWillUnmount() {
        clearInterval(intVar);
    }

    reload = () => {
        this.table.current.reload();
        this.tableAbsent.current.reload();
    };

    async checkRegularisationRequests() {
        let response = await Request.getUserRegularisationRequests()
        this.setState({ previousRegularisationRequests: response.total })
    }

    async getCompanyDetails() {
        let { currentUser } = this.props
        let response = await Request.getCompanySetting({ businessId: currentUser.businessId })
        this.setState({ trackAllUserAttendence: response.trackAllUserAttendence })
    }

    handleEdit = (record) => {
        this.setState({ showRegularizeDrawer: true, attendenceRecord: record })
    }

    closeEditForm = () => {
        this.setState({ showRegularizeDrawer: false, attendenceRecord: {} });
        this.table.current.reload()
    }

    checkPolicyAccepted = async () => {
        let currentUser = JSON.parse(localStorage.getItem('user'));
        let response = await Request.getUserById({ id: currentUser._id });
        let { _doc } = response

        this.setState({ user: _doc })
        if (!_doc.policyAccepted) {
            this.setState({ showPoliciesDrawer: true })
        }
    }

    absenteesRequest = params => {
        return new Promise(async (resolve) => {
            let { selectedDate } = this.state
            let response = await Request.getAbsentEmployees({ date: selectedDate })
            this.setState({ count: response.total })
            resolve(response)
        })
    }

    apiRequest = params => {
        return new Promise(async resolve => {
            let time = this.getCurrentUser();
            if (this.state.time && this.state.time.from) {
                params.time = this.state.time;
            }
            params.userId = activeUser._id;
            this.setState({ exportParams: params, shiftTime: time })
            let data = await Request.getUserAttendance({
                ...params
            });
            resolve(data)
        })
    }
    qrCodePrint() {
        var prtContent = document.getElementById("qr-code-section");
        var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
        WinPrint.document.write(prtContent.innerHTML);
        WinPrint.document.close();
        WinPrint.focus();
        WinPrint.print();
        WinPrint.close();
    }


    render() {
        const { currentUser } = this.props
        const disabledDate = (current) => {
            // Can not select days before today and today
            return current && current > moment().endOf('day');
        };
        const { total, defaultPageSize, showPoliciesDrawer, policies, showRegularizeDrawer, attendenceRecord, previousRegularisationRequests, shiftTime } = this.state;
        const columns = [
            {
                title: 'Attendance Date',
                key: 'userAttendanceDate',
                render: (text, record) => (
                    <div> {moment(record._id.attendanceDate).format('DD-MM-YYYY')} </div>
                )
            },
            {
                title: 'Total Worked',
                key: 'totalHours',
                render: (text, record) => {
                    text = parseFloat(text);
                    if (text > shiftTime) {
                        return (
                            <div style={{ background: '#EEE8AA', maxWidth: '50%', textAlign: 'center', borderRadius: '20px', padding: '5px 1px' }}> Hours:- {text.toFixed(2)} </div>
                        )
                    } else if (text < shiftTime) {
                        return (
                            <div style={{ background: '#DC143C', color: 'white', maxWidth: '50%', textAlign: 'center', borderRadius: '20px', padding: '5px 1px' }}> Hours:- {text.toFixed(2)} </div>
                        )
                    } else if (text === shiftTime) {
                        return (
                            <div style={{ background: '#2C6E49', color: 'white', maxWidth: '50%', textAlign: 'center', borderRadius: '20px', padding: '5px 1px' }}> Hours:- {text.toFixed(2)} </div>
                        )
                    }
                }
            },
            {
                title: 'Total Login Attemtps',
                key: 'totalAttempts',
                render: (text, record) => (
                    <div> Count:- {text} </div>
                )
            },
            {
                title: 'Logs (Login - Logout)',
                key: 'logs',
                render: (text, record) => {
                    const { loginAt } = record;
                    let loginHtml = loginAt.join(' <br /> ');
                    return (
                        <div dangerouslySetInnerHTML={{ __html: loginHtml }}></div>
                    )
                }
            },
            {
                title: 'Action',
                key: 'operation',
                dataindex: 'operation',
                width: 130,
                render: (text, record) => (
                    <div>
                        {
                            record._id.attendanceDate !== currentDate || previousRegularisationRequests >= 2 ? null
                                :
                                <Tooltip title="Request Regularisation">
                                    <Button
                                        size={'small'}
                                        shape="circle"
                                        onClick={() => this.handleEdit(record)}
                                        icon="forward"
                                    />
                                </Tooltip>
                        }

                    </div>
                )
            }
        ]

        const absentColumns = [
            {
                title: 'Employee Name',
                key: 'name'
            },
            {
                title: 'Mobile Number',
                key: 'contactNo',
            },
            {
                title: 'Email Id',
                key: 'email',
            },
            {
                title: 'Group Name',
                key: 'userGroup.groupName',
            }
        ];

        return (
            <PageHeaderWrapper
                title={currentUser && 'Timer '}
            >
                {
                    showRegularizeDrawer ?
                        <RegulariseAttendence oldAttendence={attendenceRecord} onClose={this.closeEditForm} />
                        : null
                }
                <PendingTaskList />
                {this.state.trackAllUserAttendence ?
                    <Card bordered={true} title="Current Month Login History" >
                        <TableComp
                            ref={this.table}
                            columns={columns}
                            apiRequest={this.apiRequest}
                            extraProps={{ scroll: { x: 900 } }}
                            pagination={{
                                showSizeChanger: false,
                                defaultPageSize: 30,
                                pageSizeOptions: ['10', '20', '50', '100', '1000']
                            }}
                        />
                    </Card>
                    : null}
                {/* Absentees */}
                {/* {this.state.trackAllUserAttendence ?
                    <RightsWrapper myRight={"allAbsentees.view"} >
                        <Card bordered={true} title="Absentees" style={{ marginTop: '20px' }} extra={
                            <DatePicker
                                defaultValue={
                                    this.state.todayDate &&
                                    moment(this.state.todayDate, 'YYYY-MM-DD')
                                }
                                disabledDate={disabledDate}
                                onChange={selectedDate => {
                                    this.setState({
                                        selectedDate: selectedDate && moment(selectedDate).format('YYYY-MM-DD')
                                    }, () => {
                                        this.reload();
                                    })
                                }}
                            />
                        } >
                            <TableComp
                                ref={this.tableAbsent}
                                columns={absentColumns}
                                apiRequest={this.absenteesRequest}
                                extraProps={{ scroll: { x: 900 } }}
                                pagination={{
                                    showSizeChanger: false,
                                    defaultPageSize: 30,
                                    pageSizeOptions: ['10', '20', '50', '100', '1000']
                                }}
                            />
                        </Card>
                    </RightsWrapper>
                    : null} */}
                {
                    policies && policies.url ?
                        <Drawer
                            title="Accept Policy"
                            placement="right"
                            closable={false}
                            onClose={() => {
                                this.setState({
                                    showPoliciesDrawer: false
                                })
                            }}
                            visible={showPoliciesDrawer}
                            width={"100%"}>
                            <div>
                                <AcceptPolicy
                                    loading={this.props.loading}
                                    policies={this.state.policies}
                                    handleSubmit={
                                        async (values) => {
                                            let { user } = this.state
                                            values._id = user._id
                                            let response = await Request.updatePolicyAccept(values);
                                            if (!response.error) {
                                                notification.success({
                                                    message: response.message
                                                })
                                                this.setState({
                                                    showPoliciesDrawer: false
                                                })
                                            }
                                        }
                                    }
                                />
                            </div>
                        </Drawer>
                        : null
                }
                {/* <Card bordered={true} title="Student Panel QR Code And Web Link" style={{ marginTop: '20px' }} >
                    <Row>
                        <Col span={7}>
                            <div id='qr-code-section'>
                                <QRCode
                                    size={256}
                                    style={{ height: "auto", maxWidth: '60%', width: "80%" }}
                                    value={`${currentUser.businessId}-${currentUser.userBranch}`}
                                    viewBox={`0 0 256 256`}
                                />
                            </div>
                            <Button style={{ marginTop: '20px' }} className="btn btn-primary" onClick={this.qrCodePrint} type="button">Print</Button>
                        </Col>
                        <Col span={17}>
                            <span>
                                <b>Web Link:- </b>
                                <input
                                    type='text'
                                    className='form-control'
                                    id='webLinkCopy'
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        var copyText = document.getElementById("webLinkCopy");
                                        copyText.select();
                                        copyText.setSelectionRange(0, 99999);
                                        navigator.clipboard.writeText(copyText.value);
                                        notification.success({ message: "Copied To Clipboard." })
                                    }}
                                    readOnly
                                    value={`https://student.tenagents.com/register?businessId=${currentUser.businessId}&brnch=${currentUser.userBranch}`}
                                />
                            </span>
                        </Col>
                    </Row>
                </Card> */}
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories,
    loading: global.buttonLoading,
    currentUser: global.currentUser

})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)
    (Dashboard)
